<template>
  <public-layout class="page-astronaut-program" theme="transparent">
    <section class="hero lvl2">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <h1 class="claim">Future Astronaut Program</h1>
              <h2 class="subclaim">Reach for the stars from right here on Earth!</h2>
              <br/>
              <p class="description">
                Designed to develop Life Skills and STEAM (Science, Technology, Engineering, Arts and Math) in children. Inspired by the wonders of space exploration.
                 Based on Finnish education expertise, and adapts the real NASA Training for astronauts. Empowers early childhood educators to promote scientific thinking, mindfulness, physical activity, and teamwork within their classroom.
              </p>
              <!-- <p class="description">Each week contains four outcome-oriented Fun Learning lessons, designed for use during activity periods of a school day. The lessons and their activities guide the children to develop the core skill objectives, while improving motor skills, communication, collaboration, self-awareness and much more!</p> -->
              <div class="columns">
                <div class="column is-4">
                  <h5>Program duration</h5>
                  <p>12 weeks</p>
                </div>
                <div class="column is-4">
                  <h5>Recommended for</h5>
                  <p>Kindergarten</p>
                </div>
                <div class="column is-4">
                  <h5>Fee</h5>
                  <p>Free</p>
                </div>
              </div>
              <p class="hero-actions">
                <!-- <Button size="large" :to="{ name: 'course', params: { courseId: astronautProgramId, langId: 1 } }" v-if="isAuthenticated">Access the course</Button>
                <Button size="large" :to="{ name: 'login', params: { redirect: `courses/${astronautProgramId}` } }" v-else>Access now</Button> -->
                <router-link class="button button-large button-secondary" :to="{ name: 'future-explorers' }">Go Back</router-link>
                <!-- <Button size="large" type="secondary">Free Preview</Button> -->
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/astronaut-program.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr/>

    <section class="section course-info is-left-aligned">
      <div class="container">
        <div class="columns">
          <div class="column is-4 is-offset-1">
            <figure class="image">
              <img src="static/img/assets/big-themes.jpg" alt="">
            </figure>
          </div>
          <div class="column is-5 is-offset-1">
            <h2 class="section-title">Introducing big themes to little kids in fun ways!</h2>
            <p class="content">
              The Future Astronaut Program
              <ul>
                <li>Fuels curiosity, creativity and innovation in young children and educators.</li>
                <li>Each week contains four outcome-oriented Fun Learning lessons, designed for use during activity periods of a school day.</li>
                <li>Introduces themes such as international cooperation and environmental conservation in fun and exciting ways.</li>
                <li>Guides children to develop the core skill objectives, while improving motor skills, communication, collaboration, self-awareness and much more!</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section course-modules is-left-aligned">
      <div class="container">
        <h2 class="section-title has-text-centered"><strong>Take a Fun Learning trip to space</strong></h2>
        <div class="columns">
          <div class="column is-8">
            <div class="timeline">
              <div class="timeline-item" v-for="(module, index) in modules" :key="index">
                <div class="timeline-item-label">{{ `WEEK ${module.id}` }}</div>
                <div class="timeline-item-title">{{ module.title }}</div>
                <p class="timeline-item-description">{{ module.description }}</p>
              </div>
            </div>
            <Button size="medium" type="secondary" v-if="!modulesShowAll" :onClick="showAllModules">{{ `See all ${modulesData.length} weeks` }}</Button>
          </div>
          <div class="column is-4">

          </div>
        </div>
      </div>
    </section>

    <section class="hero section-cta">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="title">
                Interested in the Fun Academy Future<br/>Astronaut Program?
              </p>
              <p class="product-cta">
                <Button :to="{ name: 'login' }" size="large">Get Started for Free</Button>
              </p>
            </div>
            <div class="column is-narrow">
              <div class="image-wrapper">
                <img src="static/img/characters/large/soca-2.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="section purchase">
      <div class="container">
        <div class="card is-clickable purchase-card">
          <div class="card-content">
            <h3>
              <span class="name">Astronaut Program</span>
              <span class="price">240€</span>
              total
            </h3>
            <p class="description">Learn to build the deep learning models that are revolutionizing artificial intelligence</p>
            <Button size="medium">Enroll now</Button>
          </div>
        </div>
      </div>
    </section> -->
  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import Button from '@/components/Button'
import API from '@/utils/ApiConfig'

export default {
  name: 'astronaut-program',

  components: {
    PublicLayout,
    Button
  },

  computed: {
    modules () {
      return this.modulesShowAll ? this.modulesData : this.modulesData.slice(0, 4)
    },

    isAuthenticated () {
      return this.$store.state.isAuthenticated
    }
  },

  methods: {
    showAllModules () {
      this.modulesShowAll = true
    }
  },

  data () {
    return {
      modulesShowAll: false,
      astronautProgramId: API.AP_ID,
      modulesData: [
        { id: 1, title: 'Becoming an Astronaut', description: 'To become an astronaut, you must really want it in the first place. Discover and develop the passion, drive and motivation necessary to achieve your life goals.' },
        { id: 2, title: 'Our Universe', description: 'Train your astronaut body, and figure out the scale of our Solar System. Start using the basic terminology to form a foundation for further studies in space and astronauts.' },
        { id: 3, title: 'Physical Training', description: 'Discover the concept of constellations and learn the fundamentals of navigation. Participate in physical training. Use your creativity and design agility tracks in groups.' },
        { id: 4, title: 'The Journey', description: 'Learn about transportation and rockets. Simulate and understand the force that causes a rocket to take off. Discover the importance of communication, responsibility and becoming a trusted team member.' },
        { id: 5, title: 'Training Our Mind', description: 'Challenge and train your mind. Develop your communication and language skills. Prepare your fine motor skills for astronaut-level assembly work.' },
        { id: 6, title: 'Life in Space', description: 'Learn about day to day life in a zero gravity environment. Focus on the importance of simple tasks. Train your mind and body for better balance and coordination.' },
        { id: 7, title: 'Takeoff!', description: 'Explore the forces of spaceflight, mainly thrust and drag, in astronaut physical training. Learn how we fly. Study the effects of weight and lift by experimenting with paper plane building.' },
        { id: 8, title: 'Exploring Space', description: 'Discover the value of exploration, fuel your curiosity and unleash your creativity. Dare to know the unknown. Take on a climbing challenge and develop your body strength.' },
        { id: 9, title: 'Survival Skills', description: 'Learn through play about astronaut survival skills and how to assemble your own survival pack. Discover the importance of teamwork and depending on each other when overcoming new challenges.' },
        { id: 10, title: 'Scientific Research', description: 'Understand the importance of scientific research, innovation and discovery. Explore an astronaut’s responsibilities as a scientist. Improve your fine motor skills and build muscle endurance.' },
        { id: 11, title: 'Returning to Earth', description: 'Focus on acts of kindness; an essential part of astronaut character building. Learn more about mindfulness, develop empathy and make a positive impact on your surroundings.' },
        { id: 12, title: 'Astronaut Community', description: 'Reflect on your Future Astronaut journey. Comprehend the importance of cultural respect and understanding. Connect with others, share and discover ideas which inspired you the most.' }
      ]
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.page-astronaut-program {

  .description {
    margin-bottom: 1.5rem;
  }

  .columns h5 {
    margin-bottom: .5rem;
    font-weight: $font-weight-semibold;
  }

  .hero-actions {
    margin-top: 2.5rem;

    > :not(:first-child) {
      margin-left: 1.5rem;
    }
  }
}

.course-info {

  .section-title {
    margin-top: 2rem;
    @include text-size-xxl();
    font-weight: $font-weight-semibold;
  }
}

.course-modules {

  .section-title {
    margin-bottom: 4rem;
    @include text-size-xxl();
  }
}

.timeline {

  .timeline-item {
    padding-left: 3rem;
    padding-bottom: 3rem;
    @include text-size-s();
    position: relative;

    &:not(:last-child)::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      border-right: 1px solid $color-gray-light;
      transform: translate(6px, calc(3.2rem + 6px));
    }

    &::after {
      content: '';
      position: absolute;
      top: 3.2rem;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: $color-brand-main;
    }
  }

  .timeline-item-label {
    margin-bottom: 1rem;
    font-weight: $font-weight-semibold;
    text-transform: uppercase;
  }

  .timeline-item-title {
    margin-bottom: .5rem;
    @include text-size-xl();
    font-weight: $font-weight-semibold;
    color: $color-text-dark;
  }

  .timeline-item-description {
    margin-bottom: .5rem;
  }
}

.purchase {
  background-image: linear-gradient(-135deg, #003594 0%, #17143B 100%);
}

.purchase-card {
  max-width: 450px;
  margin: 0 auto;
  text-align: center;
  color: $color-text-light;
  position: relative;

  .card-content {
    padding: 2.5rem;
  }

  h3 {
    margin-bottom: 1.5rem;
    color: $color-text-dark;
    @include text-size-l();

    .name {
      display: block;
      margin-bottom: 2rem;
      @include text-size-xl();
      font-weight: $font-weight-semibold;
    }

    .price {
      display: block;
      margin-bottom: .5rem;
      font-size: 5rem;
      line-height: 6rem;
    }
  }

  .description {
    margin-bottom: 1.5rem;
  }

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    right: -2px;
    width: 4rem;
    height: 4rem;
    background: $color-brand-main;
    clip-path: polygon(0 0, 100% 100%, 100% 0);
  }

  &::after {
    content: '★';
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0rem .5rem 0rem 0rem;
    font-size: 1.5rem;
    color: $color-white;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/AstronautProgramPage.vue